export default function (state, payload) {
  let selectedAbteilungen = payload.selectedItems
  return {
    ...state,
    selectedAbteilungen: selectedAbteilungen,
  }
}
